import { render, staticRenderFns } from "./ActiveFlag.vue?vue&type=template&id=911368b0"
import script from "./ActiveFlag.vue?vue&type=script&lang=js"
export * from "./ActiveFlag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports